$(function () {
    if ($('#add-to-cart').length) {
        new Vue({
            store: store,
            el: '#add-to-cart',
            data: {
                product: null,
                attr1Options: [],
                attr2Options: [],
                logoOptions: [],
                validAttrCombo: [],
                attrComboInventory: [],
                ready: false,
                selectedAttr1: null,
                selectedAttr2: null,
                personalizationLabel: null,
                personalizationValue: null,
                personalizationSelection: 'none',
                personalizationPrice: null,
                logoValue: null,
                selectedProductImageId: null,
                selectedLogoId: null,
                qty: 1,
                minQty: null,
                addReview: null,
                error: null,
                amount: null,
                showSkuInventory: false,
                storeName: null,
                storeId: 0,
                allowAdd: true,
                isOneItemLimitEnforced: false,
                showSizingChart: false,
                imprintMethod: null,
                imprintMethodOptions: []
            },
            computed: {
                canAdd: function () {
                    if (!this.allowAdd) {
                        return false;
                    }
                    var canAdd = this.cartItem
                        && this.cartItem.productId
                        && this.cartItem.quantity > 0
                        && ((this.hasSkus && this.cartItem.productSkuId) || !this.hasSkus)
                        && (!this.hasPersonalization || (this.hasPersonalization && this.personalizationSelection))
                        && (!this.hasPersonalization || (this.hasPersonalization && this.personalizationSelection === 'none') || (this.personalizationSelection === 'add' && this.personalizationValue))
                        && (!this.hasLogo || (this.hasLogo && this.logoValue))
                        && (!this.requiresLogoSelection || (this.requiresLogoSelection && this.logoValue))
                        && (!this.hasImprintMethods || this.imprintMethod);

                    if (this.amountNeeded && canAdd) {
                        canAdd = this.amount && this.amount > 0;
                    }

                    return canAdd;
                },
                requiresLogoSelection: function () {
                    return this.logoOptions && this.logoOptions.length >= 2;
                },
                hasSkus: function () {
                    return this.product && this.product.skus && this.product.skus.length;
                },
                hasPersonalization: function () {
                    return this.product && this.product.hasPersonalization;
                },
                hasLogo: function () {
                    return this.product && this.product.hasLogo;
                },
                isGiftCard: function () {
                    return this.product && this.product.productType && this.product.productType.id === CONSTANTS.PRODUCT_TYPE.GIFT_CARD;
                },
                amountNeeded: function () {
                    return this.isGiftCard && this.product && (!this.product.price || this.product.price <= 0);
                },
                hasImprintMethods: function () {
                    return this.imprintMethodOptions && this.imprintMethodOptions.length > 0;
                },
                singleImprintMethod: function () {
                    return this.imprintMethodOptions.length === 1 ? this.imprintMethodOptions[0] : null;
                },
                sku: function () {
                    var skus = [],
                        vm = this;
                    if (vm.product && vm.product.skus && vm.product.skus.length) {
                        skus = vm.product.skus;

                        if (vm.selectedAttr1) {
                            skus = skus.filter(function (obj) {
                                return obj.attr1 === vm.selectedAttr1;
                            });
                        }
                        if (vm.selectedAttr2) {
                            skus = skus.filter(function (obj) {
                                return obj.attr2 === vm.selectedAttr2;
                            })
                        }

                        if (vm.selectedAttr1 || vm.selectedAttr2) {
                            //update inventory information
                            vm.selectedAttr1 ??= "";
                            vm.selectedAttr2 ??= "";
                            vm.showSkuInventory = false;
                            var inventoryArea = document.getElementById('sku-inventory-information');
                            if (inventoryArea) {
                                inventoryArea.innerHTML = "";
                                var inventoryItems = vm.attrComboInventory.filter(function (obj) {
                                    return obj.attr1 == vm.selectedAttr1 && obj.attr2 == vm.selectedAttr2;
                                });
                                if (inventoryItems.length == 1) {
                                    var inventoryHtml = "";
                                    var inventoryItem = inventoryItems[0];
                                    var inventory = inventoryItem.inventory;
                                    if (inventory == 0 || inventoryItem.outOfStock) {
                                        inventoryHtml = "<div class='mt-3 text-danger'><strong>OUT OF STOCK</strong</div>";
                                    }
                                    if (inventory > 0) {
                                        inventoryHtml = "<div class='mt-3'><strong>Available Quantity: </strong>" + inventory + "</div>";
                                    }
                                    if (inventoryHtml != "") {
                                        inventoryArea.innerHTML = inventoryHtml;
                                        vm.showSkuInventory = true;
                                    }
                                }
                            }
                        }
                    }

                    if (skus.length == 1) {
                        var selectedSku = skus[0];
                        vm.selectedAttr1 = selectedSku.attr1;
                        vm.selectedAttr2 = selectedSku.attr2;

                        // Populate logo options if SKU has store logos
                        vm.logoOptions = [];
                        if (selectedSku.storeLogos && selectedSku.storeLogos.length) {
                            vm.logoOptions = selectedSku.storeLogos;
                            // Reset selected logo when options change
                            if (vm.logoOptions.length >= 2) {
                                vm.logoValue = null;
                                vm.selectedLogoId = null;
                                vm.selectedProductImageId = null;
                            } else if (vm.logoOptions.length === 1) {
                                // Auto-select if only one logo
                                var logo = vm.logoOptions[0];
                                vm.logoValue = logo.name;
                                vm.selectedLogoId = logo.storeLogoId;
                                vm.selectedProductImageId = logo.storeProductImageId;
                            }
                        }

                        return selectedSku;

                    }

                    return null;
                },
                price: function () {
                    var price = null;
                    if (this.product) {
                        price = this.product.price;
                    }
                    if (this.sku && this.sku.price && this.sku.price > 0) {
                        price = this.sku.price;
                    }
                    return price;
                },
                cartItem: function () {
                    var item = null;
                    if (this.product) {
                        item = {
                            productId: this.product.id
                        };

                        if (this.sku) {
                            item.productSkuId = this.sku.id;
                        }
                        if (this.qty) {
                            item.quantity = this.qty;
                        }
                        if (this.personalizationSelection === 'add') {
                            item.hasPersonalization = true;
                            if (this.personalizationValue) {
                                item.personalizationValue = this.personalizationValue;
                            }
                        } else {
                            item.hasPersonalization = false;
                        }
                        if (this.logoValue) {
                            item.logoValue = this.logoValue;
                        }
                        if (this.selectedProductImageId) {
                            item.productImageId = this.selectedProductImageId;
                        }
                        if (this.product.departmentId) {
                            item.departmentId = this.product.departmentId;
                        }
                        if (this.selectedLogoId) {
                            item.logoId = this.selectedLogoId;
                        }
                        if (this.amountNeeded) {
                            item.amount = this.amount;
                        }
                        if (this.imprintMethod) {
                            item.imprintMethod = this.imprintMethod;
                        }
                    }
                    return item;
                }
            },
            watch: {
                selectedAttr1: function() {
                    this.rotateToMatchingImage();
                },
                selectedAttr2: function() {
                    this.rotateToMatchingImage();
                },
                logoValue: function() {
                    this.updateLogoSelection();
                    this.rotateToMatchingImage();
                }
            },
            methods: {
                updateLogoSelection: function() {
                    var vm = this;
                    // Find the logo object that matches the selected logoValue
                    if (vm.logoValue && vm.logoOptions && vm.logoOptions.length) {
                        var matchingLogo = vm.logoOptions.find(function(logo) {
                            return logo.name === vm.logoValue;
                        });
                        if (matchingLogo) {
                            vm.selectedLogoId = matchingLogo.storeLogoId;
                            vm.selectedProductImageId = matchingLogo.storeProductImageId;
                        } else {
                            vm.selectedLogoId = null;
                            vm.selectedProductImageId = null;
                        }
                    } else {
                        vm.selectedLogoId = null;
                        vm.selectedProductImageId = null;
                    }
                },
                onLogoChange: function(logo) {
                    var vm = this;
                    if (logo) {
                        vm.selectedLogoId = logo.storeLogoId;
                        vm.selectedProductImageId = logo.storeProductImageId;
                    }
                },
                rotateToMatchingImage: function() {
                    var vm = this;

                    // Only proceed if we have attributes or logo selected and we have images
                    if (!vm.selectedAttr1 && !vm.selectedAttr2 && !vm.selectedLogoId) {
                        return;
                    }

                    if (!vm.product || !vm.product.images || vm.product.images.length <= 1) {
                        return;
                    }

                    // Normalize selected values for comparison
                    var selectedAttr1 = (vm.selectedAttr1 || '').trim();
                    var selectedAttr2 = (vm.selectedAttr2 || '').trim();
                    var selectedLogoId = vm.selectedLogoId;

                    // Find the first image that matches the selected attributes and logo
                    var matchingImageIndex = -1;
                    vm.product.images.forEach(function(image, index) {
                        if (matchingImageIndex !== -1) {
                            return; // Already found a match
                        }

                        // Parse attr1Values and attr2Values (comma-separated)
                        var attr1Values = image.attr1Values ? image.attr1Values.split(',').map(function(v) { return v.trim(); }) : [];
                        var attr2Values = image.attr2Values ? image.attr2Values.split(',').map(function(v) { return v.trim(); }) : [];

                        // Check if this image matches the selected attributes
                        var attr1Matches = attr1Values.length === 0 || attr1Values.indexOf(selectedAttr1) !== -1 || selectedAttr1 === '';
                        var attr2Matches = attr2Values.length === 0 || attr2Values.indexOf(selectedAttr2) !== -1 || selectedAttr2 === '';

                        // Check if this image matches the selected logo
                        var logoMatches = true;
                        if (selectedLogoId) {
                            logoMatches = image.storeLogoId === selectedLogoId;
                        }

                        if (attr1Matches && attr2Matches && logoMatches) {
                            matchingImageIndex = index;
                        }
                    });

                    // If we found a matching image, rotate the Flickity carousel
                    if (matchingImageIndex !== -1 && $('.carousel-wrapper .carousel').length) {
                        $('.carousel-wrapper .carousel').flickity('select', matchingImageIndex);
                    }
                },
                formatPrice: function (price) {
                    if (price) {
                        var formatter = new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        });

                        return formatter.format(price);
                    }
                    return '--';

                },
                loadAttributes: function () {
                    var vm = this;

                    if (vm.product) {
                        vm.minQty = vm.product.minQuantity;
                        vm.personalizationLabel = vm.product.personalizationLabel;
                        vm.personalizationPrice = vm.product.personalizationPrice;
                        vm.storeId = vm.product.storeId;
                        vm.storeName = vm.product.storeName;
                        vm.allowAdd = vm.product.allowAdd;
                        if (vm.product.skus) {
                            vm.product.skus.forEach(function (sku, i) {
                                var attr1 = sku.attr1;
                                var attr2 = sku.attr2;

                                if ($.type(attr1) === "string") {
                                    attr1 = attr1.trim();
                                }
                                if ($.type(attr2) === "string") {
                                    attr2 = attr2.trim();
                                }

                                vm.validAttrCombo.push(attr1 + '||' + attr2)
                                var inventory = sku.inventory;
                                if (sku.outOfStock) {
                                    inventory = 0;
                                }
                                if (inventory == null) {
                                    inventory = -1;
                                }
                                //debugger;
                                var inventoryInfo = {
                                    "attr1": attr1,
                                    "attr2": attr2,
                                    "inventory": inventory,
                                    "outOfStock": sku.outOfStock
                                };
                                vm.attrComboInventory.push(inventoryInfo);

                                if (['', null, undefined].indexOf(attr1) === -1) {
                                    if (vm.attr1Options.indexOf(attr1) === -1) {
                                        vm.attr1Options.push(attr1);
                                    }
                                }
                                if (['', null, undefined].indexOf(attr2) === -1) {
                                    if (vm.attr2Options.indexOf(attr2) === -1) {
                                        vm.attr2Options.push(attr2);
                                    }
                                }
                            });

                            if (vm.attr1Options.length) {
                                vm.attr1Label = vm.product.attr1Label;

                            }
                            if (vm.attr2Options.length) {
                                vm.attr2Label = vm.product.attr2Label;
                            }
                        }

                        // Parse imprint methods from pipe-delimited string
                        vm.imprintMethodOptions = [];
                        if (vm.product.imprintMethods) {
                            vm.imprintMethodOptions = vm.product.imprintMethods.split('|');
                        }

                        // Auto-select if only one imprint method
                        if (vm.imprintMethodOptions.length === 1) {
                            vm.imprintMethod = vm.imprintMethodOptions[0];
                        }
                    }
                },
                addToCart: function () {
                    var vm = this;

                    var quantityInput = document.getElementById('qty');
                    var quantity = parseInt(quantityInput.value);

                    if (!vm.hasSkus && quantity < vm.minQty) {
                        vm.error = 'Please enter a quantity equal to or greater than ' + vm.minQty;
                        return;
                    }

                    vm.error = null;
                    this.cartItem.quantity = quantity;
                    axios.post('/api/cart/add', this.cartItem).then(function (resp) {
                        if (resp && resp.data) {

                            if (vm.isOneItemLimitEnforced) {
                                vm.allowAdd = false;
                            }

                            vm.addReview = resp.data;
                        }
                        vm.$store.dispatch('updateCartSummary');
                    }).catch(function (error) {
                        vm.error = error.response.data.error;
                    })
                }
            },
            mounted: function () {
                var productJson = $('#productJson').text();
                var settingsJson = $('#settingsJson').text();
                this.product = JSON.parse(productJson);
                this.isOneItemLimitEnforced = JSON.parse(settingsJson).isOneItemLimitEnforced;

                this.loadAttributes();
            }
        });
    }
});